// extracted by mini-css-extract-plugin
export var Section = "News-module--Section--9akBh";
export var LangHY = "News-module--LangHY--TifJu";
export var ItemDesc = "News-module--ItemDesc--w1kNg";
export var ItemMonth = "News-module--ItemMonth--g8lXL";
export var Item = "News-module--Item--BFDdr";
export var Line = "News-module--Line--Gg6jx";
export var ItemNumber = "News-module--ItemNumber--wqx8p";
export var ItemContent = "News-module--ItemContent--j93qn";
export var ItemTitle = "News-module--ItemTitle--kATyr";
export var ItemDate = "News-module--ItemDate--Hi26e";
export var arrowLeft = "News-module--arrowLeft--m2Iut";
export var arrowRight = "News-module--arrowRight--r-0ug";